import { render } from "./UIFeatures.vue?vue&type=template&id=325e9166"
import script from "./UIFeatures.vue?vue&type=script&lang=js"
export * from "./UIFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/settings/UIFeatures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "325e9166"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('325e9166', __exports__)) {
    api.reload('325e9166', __exports__)
  }
  
  module.hot.accept("./UIFeatures.vue?vue&type=template&id=325e9166", () => {
    api.rerender('325e9166', render)
  })

}


export default __exports__